try {
    window._ = require('lodash/core');

    //Extra lodash functions added
    window._uniq = require('lodash/uniq');
    window._split = require('lodash/split');
    window._join = require('lodash/join');
    window._toStr = require('lodash/toString');
    window._lowerCase = require('lodash/lowerCase');
    window._orderBy = require('lodash/orderBy');

    window.Mark = require('mark.js');

    window.axios = require('axios');
    
    window.axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    //Extracted bootstrap functions in app.js
    // window.bootstrap = require('bootstrap');

} catch (e) {}